$(function(){
    $(document).ready(function() {
        $("#video-tap-to-unmute").on('click touchend', function(e) {
            console.log('tapped');
            e.preventDefault();
            e.stopPropagation();
            var video = $("#hero-video").get(0);
            video.muted = false;
            $(this).addClass('tapped');
        });

        $("#hero-video-play").on('click touchend', function(e) {
            e.preventDefault();
            e.stopPropagation();
            var video = $("#hero-video").get(0);
            var popup = $("#hero-video-popup");
            popup.addClass('showing');
            setTimeout(function() {
                popup.addClass('open');
                setTimeout(function() {

                    if ( window.innerWidth < 1024 ) {
                        video.load();
                        video.muted = true;

                        video.addEventListener('canplaythrough', videoCanPlay);
                    }
                    else {
                        video.play();
                    }
                }, 750);
            }, 250);
        });

        function videoCanPlay() {
            var video = $("#hero-video").get(0);
            console.log('canplaythrough');
            video.play();

            video.removeEventListener('canplaythrough', videoCanPlay);
        }

        function closeVideoPopup() {
            console.log('closeVideoPopup');
            var popup = $("#hero-video-popup");
            popup.removeClass('showing');
            var video = $("#hero-video").get(0);
            video.pause();
            video.currentTime = 0;
            $("#video-tap-to-unmute").removeClass('tapped');
        }

        $("#hero-video-popup-close").click(function(e) {
            e.preventDefault();
            var popup = $("#hero-video-popup");
            popup.removeClass('open');
            setTimeout(closeVideoPopup, 600);
        });

        $("#hero-video-popup").on('click touchend', function(e) {
            e.preventDefault();
            e.stopPropagation();
            var clicked = $(e.target);
            var clickedID = clicked.attr('id');
            if ( clickedID !== 'hero-video' && clickedID !== 'hero-video-popup-close' && clicked.parents('#hero-video').length === 0 && clickedID !== 'video-tap-to-unmute') {
                var popup = $("#hero-video-popup");
                popup.removeClass('open');
                setTimeout( closeVideoPopup, 600);
            }
        });

    });
});